var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_6992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.35239 13.5791L6.18214 16.7493C5.62141 17.3097 4.86106 17.6246 4.06827 17.6246C3.27548 17.6246 2.51513 17.3097 1.95439 16.7493L1.25014 16.0451C0.689792 15.4846 0.375 14.7245 0.375 13.9319C0.375 13.1394 0.689792 12.3793 1.25014 11.8188L5.82964 7.23855C6.39038 6.67811 7.15073 6.36328 7.94352 6.36328C8.73631 6.36328 9.49666 6.67811 10.0574 7.23855L10.7616 7.94355",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64753 4.41942L11.8178 1.24992C12.0953 0.972234 12.4249 0.751955 12.7876 0.601666C13.1503 0.451378 13.539 0.374023 13.9317 0.374023C14.3243 0.374023 14.713 0.451378 15.0757 0.601666C15.4384 0.751955 15.768 0.972234 16.0455 1.24992L16.7498 1.95342C17.3101 2.5139 17.6249 3.27399 17.6249 4.06654C17.6249 4.85909 17.3101 5.61919 16.7498 6.17967L12.1703 10.7599C11.8927 11.0376 11.5632 11.2579 11.2005 11.4082C10.8378 11.5585 10.449 11.6358 10.0564 11.6358C9.6638 11.6358 9.27503 11.5585 8.91233 11.4082C8.54962 11.2579 8.22008 11.0376 7.94253 10.7599L7.23828 10.0549",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_6992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgBack);
export default __webpack_public_path__ + "static/media/avg-back.2eee567cb9b7150f01899d53ce626428.svg";
export { ForwardRef as ReactComponent };